// getters
const adminUsers = state => state.adminUsers

export default {
  adminUsers
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/users/getters.js